import React from 'react';
import Choices from 'choices.js';

const DropDown = ({ cssPrefix = 'dropdown-component', handleChange, labelText, value, isDisabled = false, options, children }) => {
	const [choices, setChoices] = React.useState();
	const el = React.useRef(null);

	React.useEffect(() => {
		if (el) {
			setChoices(new Choices(el.current, {
				removeItemButton: true,
				itemSelectText: '',
				classNames: {
					containerOuter: 'choices form-group formio-choices form-selector',
					containerInner: 'form-control ui fluid selection dropdown'
				},
				addItemText: false,
				noResultsText: 'No results found',
				noChoicesText: 'No choices to choose from',
				searchPlaceholderValue: 'Type to search',
				searchResultLimit: 100,
				shouldSort: false,
				searchEnabled: true
			}));

			return function cleanup() {
				if (choices) {
					choices.destroy();
				}
			};
		}
	}, [el]);

	React.useEffect(() => {
		if (choices && options) {
			//let list = children.map((i) => ({ value: i.props.value, label: i.props.children }));
			choices.clearChoices();
			choices.setChoices(options);
		}
	}, [JSON.stringify(options)]);

	React.useEffect(() => {
		if (choices) {
			if (isDisabled) {
				choices.disable();
			} else {
				choices.enable();
            }
        }
	}, [isDisabled]);

	return (
		<div className={`${cssPrefix}__container dropdown__container`}>
			<label className={`${cssPrefix}__label dropdown__label`}>{labelText}</label>
			<select className={`${cssPrefix}__select dropdown__select`} onChange={handleChange} value={value} disabled={isDisabled} ref={el}>
				{children}
			</select>
		</div>
	);
};

export default DropDown;
